<template>
  <el-dialog title="取消订单确认" :visible.sync="dialogVisible" width="50%" :before-close="handleClose">
    <div class="modal-body">
      <el-form label-width="120px">
        <el-form-item label="订单号：">
          <span>{{ cancleOrderCartInfo.orderId }}</span>
        </el-form-item>
        <el-form-item label="商品信息：">
          <div v-for="(cart, index) in cancleOrderCartInfo.storeOrderCartDtos" :key="index">
            {{ cart.prodName }} x {{ cart.cartNum }}
          </div>
        </el-form-item>
        <el-form-item label="提示：">
          <span style="color: #f56c6c;">确定要取消此订单吗？取消后将恢复商品库存。</span>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">关闭</el-button>
      <el-button type="danger" @click="_cancleOrderCart">确定取消</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { cancleOrderCart } from '@/api/order/storeOrderCartApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'CancleOrderCart',
  data() {
    return {
      dialogVisible: false,
      cancleOrderCartInfo: {
        orderId: '',
        cartId: '',
        storeOrderCartDtos: []
      }
    }
  },
  methods: {
    open(order) {
      this.cancleOrderCartInfo.orderId = order.orderId
      // 获取第一个cartId用于取消订单
      if (order.storeOrderCartDtos && order.storeOrderCartDtos.length > 0) {
        this.cancleOrderCartInfo.cartId = order.storeOrderCartDtos[0].cartId
        this.cancleOrderCartInfo.storeOrderCartDtos = order.storeOrderCartDtos
      } else {
        // 如果没有storeOrderCartDtos，尝试从order对象中获取cartId
        this.cancleOrderCartInfo.cartId = order.cartId || ''
      }
      this.dialogVisible = true
    },
    handleClose() {
      this.dialogVisible = false
      this.cancleOrderCartInfo = {
        orderId: '',
        cartId: '',
        storeOrderCartDtos: []
      }
    },
    async _cancleOrderCart() {
      if (!this.cancleOrderCartInfo.cartId) {
        this.$message.error('订单购物车ID不存在')
        return
      }

      try {
        const shopId = await getShopId()
        const res = await cancleOrderCart({
          cartId: this.cancleOrderCartInfo.cartId,
          shopId: shopId
        })
        if (res.code === 0) {
          this.$message.success('取消订单成功')
          this.handleClose()
          this.$emit('success')
        } else {
          this.$message.error(res.msg || '取消订单失败')
        }
      } catch (error) {
        this.$message.error(error.message || '取消订单失败')
      }
    }
  }
}
</script>

<style scoped>
.modal-body {
  padding: 20px 0;
}
</style>
